// extracted by mini-css-extract-plugin
export default {"tx":"_8fdc9e5e7e","line":"c6f341a31b"};